import React, { Component } from 'react';
import { CQMasterDataStore } from '../../../store/cq-master-data.store';
import { observer } from 'mobx-react';

class AppliedRule extends Component<any, any>{

    constructor(props: any) {
        super(props);
    }

    render() {
        return (
            <div className="form-rules-content slds-m-bottom_x-small">
                <h2 className="slds-text-heading_small slds-m-bottom_small">Form Rule</h2>
                <ul className="slds-listbox" role="listbox" aria-label="Selected Options:" aria-orientation="horizontal">
                    <li className="slds-listbox-item" role="presentation">
                        <span className="slds-pill" role="option" aria-selected="true">
                            <span className="slds-pill__label" >visible</span>
                            <button className="slds-button" onClick={this.props.toggleModalVisibility}>
                                <span className="slds-icon_container" title="Edit">
                                    <i className="cq-icon-edit"></i>
                                </span>
                            </button>
                        </span>
                        <button onClick={this.props.deleteRule}
                            className="slds-button slds-text-color_destructive">
                            <i className="cq-icon-delete cq-2x"></i>
                        </button>
                    </li>
                </ul>
            </div>
        )
    }
}

export const AppliedRuleGridComponent = observer(AppliedRule);